import { render, staticRenderFns } from "./CriarEtapa.vue?vue&type=template&id=0d454a22&"
import script from "./CriarEtapa.vue?vue&type=script&lang=js&"
export * from "./CriarEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports